import React from "react";
import { Row, Col, Alerta, TipoAlerta } from "@intechprev/componentes-web";

import {
  CalendarioPagamentoService,
  FichaFinanceiraAssistidoService,
  FichaFinanceiraService,
  LogService,
  PlanoService,
  ProcessoBeneficioService
} from "../../../services";

import { CalendarioPagamentoEntidade, PlanoVinculadoEntidade, ProcessoBeneficioEntidade, WebCapitalSeguradoEntidade } from "../../../entidades";
import { MasterPage, NumFuncionalidade } from "../../MasterPage";
import { CapitalSegurado } from "./../CapitalSegurado";
import { CalendarioPagamento } from "./CalendarioPagamento";
import { UltimaFolha } from "./UltimaFolha";
import { SaldoAtual } from "./SaldoAtual";
import { Header } from "./Header";
import { reCAPTCHA } from "../../../helpers";
import { UltimasContribuicoes } from "./UltimasContribuicoes";
import { DMN_PLANO } from "../../../domains";

interface Props {
  plano: PlanoVinculadoEntidade;
  renderSelecionarPlano: any;
}

interface State {
  ultimaFolha: any;
  processosBeneficio: Array<ProcessoBeneficioEntidade>;
  calendario: Array<CalendarioPagamentoEntidade>;

  msgSemBeneficio: string;
  selecionarPlano: boolean;
  listaPlanos: any;

  CapitalSegurado: WebCapitalSeguradoEntidade;

  valores: {
    funeral: number,
    invalidez: number
  };

  salario: any[];

  // temCertificado: boolean;
}

export class Assistido extends React.Component<Props, State> {
  private recaptcha = new reCAPTCHA("home_assistido");

  public page = React.createRef<MasterPage>();
  constructor(props: Props) {
    super(props);

    this.state = {
      ultimaFolha: null,
      processosBeneficio: null,
      calendario: null,

      msgSemBeneficio: "Aguarde enquanto o sistema carrega suas informações.",
      selecionarPlano: false,
      listaPlanos: [],
      CapitalSegurado: null,

      valores: {
        funeral: 0,
        invalidez: 0
      },

      salario: []

      // temCertificado: false
    }
  }

  componentDidMount = async () => {
    try {
      await this.page.current.alternarLoading();
      await LogService.CriarLog(NumFuncionalidade.HOME_ASISSTIDOS);
      await this.carregarPlano();

      const CapitalSegurado = await FichaFinanceiraService.BuscarCapitalSegurado();

      if (CapitalSegurado.length > 0) {
        this.setState({
          CapitalSegurado: CapitalSegurado[0]
        });
      }

      // const temCertificado = await PlanoService.PossuiDocumentoOpcaoRMV();

      // this.setState({ temCertificado });
    } catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      alert(Error);
    }
    finally {
      await this.page.current.alternarLoading();
    }
  }

  separarFolha = (folha: any) => {
    let novaFolha: any = {
      provento: [],
      desconto: []
    }

    let countP = 0;
    let countD = 0;

    for (let f = 0; f < folha.length; f++) {
      if (folha[f].RUBRICA_PROV_DESC === "P") {
        novaFolha.provento[countP] = folha[f];
        countP++;
      }
      if (folha[f].RUBRICA_PROV_DESC === "D") {
        novaFolha.desconto[countD] = folha[f];
        countD++;
      }
    }

    return novaFolha;
  }

  condicaoCarregarBeneficio = () => {
    return (this.state.calendario ? true : false);
  }

  carregarPlano = async () => {
    try {
      // await this.page.current.alternarLoading();
      const cdPlano = this.props.plano.CD_PLANO;

      const processosBeneficio = await ProcessoBeneficioService.BuscarPorPlano(cdPlano);

      if (processosBeneficio.length > 0) {
        var ultimaFolha = await FichaFinanceiraAssistidoService.BuscarUltimaPorPlanoProcesso(cdPlano, processosBeneficio[0].CD_ESPECIE, processosBeneficio[0].ANO_PROCESSO, processosBeneficio[0].NUM_PROCESSO + "");

        ultimaFolha = this.separarFolha(ultimaFolha);

        const calendario = await CalendarioPagamentoService.BuscarPorPlano(cdPlano);

        var ultimaContribuicao = await FichaFinanceiraService.BuscarUltimaExibicaoPorPlano(this.props.plano.CD_PLANO)


        await this.setState({
          ultimaFolha,
          processosBeneficio: processosBeneficio,
          calendario,
          valores: {
            funeral: ultimaContribuicao.valorFuneral.length > 0 ? ultimaContribuicao.valorFuneral[0].LIMITE_SUP_FAIXA : 0,
            invalidez: ultimaContribuicao.valorInvalidez.length > 0 ? ultimaContribuicao.valorInvalidez[0].LIMITE_SUP_FAIXA : 0
          },
          salario: ultimaContribuicao.salario,
        });
      }
      else {
        await this.setState({
          msgSemBeneficio: "Nenhum processo de benefício disponível para este plano."
        });
      }
      // await this.page.current.alternarLoading();
    }
    catch (err) {
      await this.setState({
        msgSemBeneficio: "Houve um erro ao carregar a página, por favor tente novamente mais tarde."
      });
    }
  }

  gerarRelatorio = async () => {
    try {
      const relatorio = await PlanoService.BaixarDocumentoOpcaoRMV();

      if (navigator.msSaveBlob) {
        // IE10+ : (has Blob, but not a[download] or URL)
        return navigator.msSaveBlob(new Blob([relatorio]), "simulacoa_rmv.pdf");
      } else {
        const url = window.URL.createObjectURL(new Blob([relatorio]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "simulacoa_rmv.pdf");
        document.body.appendChild(link);

        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (e) {
      const err: any = e;
      const Error = err.response ? err.response.data : err;
      alert(typeof Error === "object" ? await Error.text() : Error);
    }
  };

  renderComBeneficio = () => {
    return (
      <>
        {this.props.renderSelecionarPlano()}

        {/* {this.state.temCertificado &&
          <Box>
            <Row>
              <Col>
                <Alerta tipo={TipoAlerta.info} mensagem={"SIMULAÇÃO DE CONTRIBUIÇÃO E BENEFÍCIO DE PECÚLIO - SP X RMV (DEZ/2022)"} />
                <Botao
                  onClick={this.gerarRelatorio}
                  titulo={"Baixar Simulação"}
                  usaLoading
                />
              </Col>
            </Row>
          </Box>
        } */}

        <Header
          processosBeneficio={this.state.processosBeneficio[0]}
          plano={this.props.plano}
        />

        <SaldoAtual
          processosBeneficio={this.state.processosBeneficio[0]}
          plano={this.props.plano}
        />

        <Row className={"mt-4"}>
          <Col tamanho={"md-6"}>
            <UltimaFolha ultimaFolha={this.state.ultimaFolha} />

            {this.props.plano.CD_PLANO === DMN_PLANO.PREVIDENCIAL_B &&
              <UltimasContribuicoes
                salario={this.state.salario}
                valorFuneral={this.state.valores.funeral}
                valorInvalidez={this.state.valores.invalidez}
              />
            }

            <CapitalSegurado
              capitalSegurado={this.state.CapitalSegurado}
              valorInvalidez={this.state.valores.funeral}
            />
          </Col>
          <Col>
            <CalendarioPagamento calendario={this.state.calendario} />
          </Col>
        </Row>
      </>
    );
  }

  renderSemBeneficio = () => {
    if (!this.state.processosBeneficio) {
      return (
        <Alerta
          tipo={TipoAlerta.danger}
          mensagem={this.state.msgSemBeneficio}
        />
      );
    }
    return null;
  }

  render() {
    return (
      <MasterPage Funcionalidade={NumFuncionalidade.HOME_ASISSTIDOS} ref={this.page} {...this.props}>
        {this.condicaoCarregarBeneficio() ?
          this.renderComBeneficio() :
          this.renderSemBeneficio()
        }
      </MasterPage>
    );
  }
}